import React from 'react';
import { Sparkles } from 'lucide-react';
import { upgradePlanMessage } from '../lib/plans';

export function PlanUpgradeNotice({ featureLabel, compact = false }) {
    return (
        <div
            className="panel"
            style={{
                marginBottom: compact ? '1rem' : '1.4rem',
                padding: compact ? '0.85rem 1rem' : '1rem 1.1rem',
                background: 'rgba(245, 158, 11, 0.06)',
                border: '1px solid rgba(245, 158, 11, 0.28)',
                display: 'flex',
                gap: 10,
                alignItems: 'flex-start',
            }}
            data-testid="plan-upgrade-notice"
        >
            <Sparkles size={18} color="var(--amber)" style={{ flexShrink: 0, marginTop: 2 }} />
            <div>
                <div style={{ fontWeight: 600, marginBottom: 4 }}>Upgrade plan</div>
                <p style={{ margin: 0, color: 'var(--text-muted)', fontSize: '0.88rem', lineHeight: 1.5 }}>
                    {upgradePlanMessage(featureLabel)}
                </p>
            </div>
        </div>
    );
}
